<section class="searchbar__section">
  <div class="searchbar-header__container">
    <div class="searchbar__text">
      @if (isFirstSection) {
        @if (title) {
          <h1 class="searchbar__text__title" [innerHTML]="title"></h1>
        }
        @if (!title && description) {
          <h1
            class="searchbar__text__description"
            [innerHTML]="description | unescape"
          ></h1>
        } @else {
          @if (description) {
            <h2
              class="searchbar__text__description"
              [innerHTML]="description | unescape"
            ></h2>
          }
        }
      }
      @if (!isFirstSection) {
        @if (title) {
          <h2 class="searchbar__text__title" [innerHTML]="title"></h2>
        }
        @if (description) {
          <h3
            class="searchbar__text__description"
            [innerHTML]="description | unescape"
          ></h3>
        }
      }
    </div>
    @if (!authService.isTeacher() || !authService.isSignedIn()) {
      <div
        class="button search-cta"
        (click)="searchService.openOrNavigateToSearch()"
        translate
      >
        texts.Search-Header-Find-Tutor-CTA
      </div>
    }
  </div>
</section>
